import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  DialogContent,
  Dialog,
  DialogActions,
  TextField,
  Switch,
} from "@mui/material";
import { toast } from "react-toastify";
import { Close, DeleteOutline } from "@mui/icons-material";
import Axios from "../axios";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useAuth } from "../auth/authContext";

const FeaturedHotels = () => {
  const { navData } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [opendel, setOpendel] = useState({ status: false, id: null });
  const [hotelId, setHotelId] = useState("");
  const [allHotels, setAllHotels] = useState([]);
  const [count, setCount] = useState(0);
  const [write, setWrite] = useState(false);

  const BACKEND_URL = process.env.REACT_APP_BACKEND;

  useEffect(() => {
    const currentPath = location.pathname;
    const matchingNavItem = navData.find((item) => item.link === currentPath);
    setWrite(!!matchingNavItem?.write);
  }, [location.pathname, navData]);

  useEffect(() => {
    getAllHotels();
  }, []);

  const getAllHotels = () => {
    Axios.post(`${BACKEND_URL}get-featured-hotels`)
      .then((res) => {
        setAllHotels(res?.data?.data?.docs || []);
        setCount(res?.data?.data?.totalDocs || 0);
      })
      .catch((err) => showError(err));
  };

  const showError = (err) => {
    toast.error(err?.response?.data?.message || "Something went wrong");
  };

  const handleFeaturedHotels = (event, id) => {
    Axios.post(`${BACKEND_URL}update-featured-hotel`, {
      listingStatus: event.target.checked,
      id,
    })
      .then((res) => {
        getAllHotels();
        toast.success(res?.data?.message || "Updated successfully");
      })
      .catch((err) => showError(err));
  };

  const deleteHotel = () => {
    Axios.post(`${BACKEND_URL}delete-featured-hotel`, { id: opendel.id })
      .then((res) => {
        getAllHotels();
        setOpendel({ status: false, id: null });
        toast.success(res?.data?.message || "Deleted successfully");
      })
      .catch((err) => showError(err));
  };

  const addFeatureHotel = () => {
    Axios.post(`${BACKEND_URL}create-featured-hotel`, { hotelId })
      .then((res) => {
        getAllHotels();
        setOpen(false);
        setHotelId("");
        toast.success(res?.data?.message || "Hotel added");
      })
      .catch((err) => showError(err));
  };

  const columns = [
    {
      name: "heroImage",
      label: "Hotel Image",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (i) => (
          <img src={allHotels[i]?.heroImage} alt="" style={{ width: 60 }} />
        ),
      },
    },
    {
      name: "hotelId",
      label: "Hotel ID",
    },
    {
      name: "name",
      label: "Hotel Name",
    },
    write && {
      name: "feature trip",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (i) => (
          <>
            <Switch
              checked={allHotels[i]?.listingStatus}
              onChange={(e) => handleFeaturedHotels(e, allHotels[i]?._id)}
            />
            <DeleteOutline
              style={{ color: "red", fontSize: 24, cursor: "pointer" }}
              onClick={() =>
                setOpendel({ status: true, id: allHotels[i]?._id })
              }
            />
          </>
        ),
      },
    },
  ].filter(Boolean);

  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    search: true,
    viewColumns: false,
    rowsPerPageOptions: [],
    count,
    download: false,
  };

  return (
    <>
      <Helmet>
        <title>Sevenly - Trip</title>
        <meta name="Trip List" content="Trip List for Home Page" />
      </Helmet>

      <h1 className="mb--12 sevenly-cursor"> — </h1>

      <div className="d-flex justify-content-between mb-4">
        <h2>Featured Hotels</h2>
        <Button
          className="w7 sevenly-btn text-white"
          onClick={() => setOpen(true)}
        >
          Add
        </Button>
      </div>

      <MUIDataTable
        title="Hotels List"
        data={allHotels}
        columns={columns}
        options={options}
      />

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        <div className="d-flex justify-content-between align-center p-3">
          <h3>Add a Hotel</h3>
          <IconButton onClick={() => setOpen(false)}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <TextField
            label="Hotel Id"
            variant="outlined"
            required
            fullWidth
            className="my-2"
            placeholder="Enter new hotel id"
            onChange={(e) => setHotelId(e.target.value)}
            value={hotelId}
          />
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button
            className="submit-button"
            variant="contained"
            onClick={addFeatureHotel}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Hotel Dialog */}
      <Dialog
        open={opendel.status}
        onClose={() => setOpendel({ status: false, id: null })}
        fullWidth
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>Delete a Hotel</h3>
          <IconButton onClick={() => setOpendel({ status: false, id: null })}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          Are you sure you want to delete this hotel?
        </DialogContent>
        <DialogActions>
          <Button
            className="cancel-button"
            onClick={() => setOpendel({ status: false, id: null })}
          >
            Cancel
          </Button>
          <Button
            className="submit-button"
            variant="contained"
            onClick={deleteHotel}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FeaturedHotels;
